import React, { Component } from 'react'
import { Subscribe } from 'unstated'

import QuestionBankStore from '../../store/QuestionBankStore'
import UserResponseStore from '../../store/UserResponseStore'
import { getMyQuestionBankList } from '../../store/selectors'

import Header from '../_presentational/Header/Header'
import QuestionBankCard from '../_presentational/QuestionBankCard/QuestionBankCard'
import QuestionBankProgressBar from '../QuestionBankProgressBar/QuestionBankProgressBar'

import { Container, AnimateEntry } from './MyDashboard-styled'

class MyDashboard extends Component {
  render() {
    const { questionBankList, goToWorkout } = this.props
    return (
      <Container>
        <Header />
        <AnimateEntry>
          {questionBankList.map(questionBank => {
            const { id, title, progressCounter, imgSrc, available } = questionBank
            const startWorkout = () => {
              goToWorkout({ questionBankId: id })
            }
            // TODO: continue workout
            return (
              <QuestionBankCard
                key={id}
                id={id}
                title={title}
                progressCounter={progressCounter}
                imgSrc={imgSrc}
                available={available}
                startWorkout={startWorkout}
                ProgressBar={QuestionBankProgressBar}
              />
            )
          })}
        </AnimateEntry>
      </Container>
    )
  }
}

export default props => {
  return (
    <Subscribe to={[QuestionBankStore, UserResponseStore]}>
      {(questionBank, userResponse) => {
        const questionBankList = getMyQuestionBankList({
          questionBankState: questionBank.state,
          userResponseState: userResponse.state,
        })
        return <MyDashboard {...props} questionBankList={questionBankList} />
      }}
    </Subscribe>
  )
}



// WEBPACK FOOTER //
// ./src/component/MyDashboard/MyDashboard.jsx